module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABEklEQVR4Xu2byw6DMAwE4f8/ur1wSHjEXUW2azJcExmyrGctJPZt8Wtf/PwbAuCAqwKfl4vSuf6uBRAAB7xbAbkFqifFuaURoDX4LxDEAcWRQAucXiAMgAGNAkDwBnBDaBQEIhAEgr0CpEB0CqhMUfdbWEpngHogdT8CGArggOwUUC2t7qcFaIGxAjAABiRPgirU1P1AEAgCwaECpAApQAp0CoR/EFFjTd1PDBKDxCAxOFKAOYA5gDkgdw6wctp7PZ0B3ge06iNANgStN+S9jgNwQHIMelvcqk8L0AK0AJNgq0D4JzELUt7r0xD0fsDo+rIDoh/Q+34I8AiEY2H5v8a8LfhX9av/DjMtJgJMS1i8wBdjXphBPPe0ywAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/buttons/STOP.png
// module id = yReY
// module chunks = 18